// extracted by mini-css-extract-plugin
export default {"infoHeader":"InfoHeader_infoHeader__JKhlz","title":"InfoHeader_title__xEUfd","details":"InfoHeader_details__XXiEI"};